"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
const input_1 = require("../../utils/input");
const StickyCard_1 = __importDefault(require("../StickyCard"));
const StickyDragOverlay_1 = __importDefault(require("../StickyDragOverlay"));
const StickyText_1 = __importDefault(require("../StickyText"));
// eslint-disable-next-line max-lines-per-function
function TextboxCard({ identifier, rect, selected, text, setSelectedID, selectedTooltype, setSelectedType, trigger, }) {
    var _a, _b;
    const [isEditing, setEditing] = (0, react_1.useState)(false);
    const bridge = (0, bridge_1.useBridge)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const textRef = (0, react_1.useRef)(null);
    const localTextRef = (0, react_1.useRef)(text);
    const [isDragging, setDragging] = (0, react_1.useState)(false);
    const tools = (0, providers_1.useToolsService)();
    const stickies = (0, hooks_1.useStickiesState)();
    const sticky = stickies.find(s => s.identifier === identifier);
    const isCanDrag = selectedTooltype !== bridge_schema_1.ToolType.StickyText ||
        (selectedTooltype === bridge_schema_1.ToolType.StickyText && !selected);
    const touchEventsSupported = (0, ui_1.isTouchEventsSupported)();
    const { isDesktop } = (0, device_1.usePlatform)();
    const isInLectureMode = localStorage.getItem('lectureMode') === 'true'; //set in the legacy code
    const [textSize, setTextSize] = (0, react_1.useState)({
        width: rect.width,
        height: rect.height,
    });
    const navigateToText = (0, react_1.useCallback)(() => {
        if (selectedTooltype !== bridge_schema_1.ToolType.StickyText) {
            bridge === null || bridge === void 0 ? void 0 : bridge.toolSelect(bridge_schema_1.ToolType.StickyText);
            tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().selectSticky(identifier);
            if (setSelectedType) {
                setSelectedType(bridge_schema_1.ToolType.StickyText);
            }
            // @ts-ignore
            window.toolkitPanelDelegate.activate(bridge_schema_1.ToolType.StickyText);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        navigate,
        selectedTooltype,
        bridge,
        setSelectedID,
        setSelectedType,
        identifier,
    ]);
    const calculateTextSize = () => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (textRef.current) {
            const textRect = (_a = textRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            setTextSize({
                width: (textRect === null || textRect === void 0 ? void 0 : textRect.width) || 0,
                height: (textRect === null || textRect === void 0 ? void 0 : textRect.height) || 0,
            });
            const updatedStickyRect = Object.assign(Object.assign({}, sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect), { width: (_d = Math.max((_c = (_b = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0, textRect === null || textRect === void 0 ? void 0 : textRect.width)) !== null && _d !== void 0 ? _d : 0, height: (_g = Math.max((_f = (_e = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _e === void 0 ? void 0 : _e.height) !== null && _f !== void 0 ? _f : 0, textRect === null || textRect === void 0 ? void 0 : textRect.height)) !== null && _g !== void 0 ? _g : 0 });
            tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({
                identifier,
                stickyRect: updatedStickyRect,
            });
        }
    };
    const focusTextField = () => {
        const element = textRef.current;
        if (element) {
            const fakeInput = document.createElement('input');
            fakeInput.setAttribute('type', 'text');
            fakeInput.setAttribute('aria-hidden', 'true');
            fakeInput.style.position = 'absolute';
            fakeInput.style.opacity = '0';
            fakeInput.style.top = '-100px';
            fakeInput.style.width = '10px';
            fakeInput.style.height = '10px';
            fakeInput.style.fontSize = '16px';
            document.body.prepend(fakeInput);
            fakeInput.focus();
            setTimeout(() => {
                element.focus();
                fakeInput.disabled = true;
                fakeInput.remove();
                (0, input_1.placeCaretAtEnd)(element);
            }, 100);
        }
        else {
            console.log('Text field element not found');
        }
    };
    const saveText = () => {
        var _a, _b;
        const updatedText = ((_b = (_a = textRef.current) === null || _a === void 0 ? void 0 : _a.innerHTML) === null || _b === void 0 ? void 0 : _b.trim()) || '';
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({
            identifier,
            text: updatedText,
        });
        calculateTextSize();
    };
    const unfocusTextField = () => {
        var _a;
        saveText();
        setEditing(false);
        (_a = textRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        //tools?.getStickiesToolManager().updateUndoRedoHistory();
    };
    const enableEditing = (0, react_1.useCallback)(() => {
        if (!isEditing) {
            if (selectedTooltype === bridge_schema_1.ToolType.StickyText) {
                focusTextField();
            }
            setEditing(true);
            navigateToText();
        }
        if (!isDesktop && selectedTooltype === bridge_schema_1.ToolType.StickyText) {
            focusTextField();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTooltype, isEditing, navigateToText]);
    const onClick = (0, react_1.useCallback)(() => {
        if (isInLectureMode) {
            return;
        }
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().selectSticky(identifier);
        if (selected) {
            enableEditing();
        }
        else if (!selected && selectedTooltype !== bridge_schema_1.ToolType.None) {
            if (setSelectedType) {
                setSelectedType(bridge_schema_1.ToolType.None);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enableEditing, identifier, selected, selectedTooltype]);
    const onDoubleClick = (0, react_1.useCallback)(() => {
        if (isInLectureMode) {
            return;
        }
        enableEditing();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enableEditing]);
    const onTextChange = (0, react_1.useCallback)(() => {
        var _a;
        localTextRef.current = ((_a = textRef.current) === null || _a === void 0 ? void 0 : _a.innerHTML) || '';
        calculateTextSize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useLayoutEffect)(() => {
        if (
        //touchEventsSupported &&
        selected &&
            selectedTooltype === bridge_schema_1.ToolType.StickyText) {
            enableEditing();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected, selectedTooltype]);
    (0, react_1.useEffect)(() => {
        const handleBlur = (event) => {
            event.preventDefault(); // Prevent default blur behavior
            focusTextField();
        };
        const onHeaderClick = (event) => {
            var _a;
            const header = document.querySelector('[data-e2e="TextFormattingPanel_Container"]');
            if (header && header.contains(event.target)) {
                event.preventDefault();
                if (textRef.current) {
                    textRef.current.addEventListener('blur', handleBlur);
                }
            }
            else {
                (_a = textRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('blur', handleBlur);
            }
        };
        document.addEventListener('mousedown', onHeaderClick);
        return () => {
            document.removeEventListener('mousedown', onHeaderClick);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (trigger) {
            saveText();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger]);
    const onOutsideClick = () => {
        unfocusTextField();
    };
    (0, react_1.useEffect)(() => {
        calculateTextSize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onDragging = (0, react_1.useCallback)(() => {
        setDragging(true);
    }, []);
    const onDragEnd = (0, react_1.useCallback)(() => {
        setDragging(false);
    }, []);
    const isOverlayVisible = isDragging && textSize.height > rect.height;
    return ((0, jsx_runtime_1.jsxs)(StickyCard_1.default, { identifier: identifier, rect: rect, canDrag: isCanDrag, onClick: onClick, onDoubleClick: onDoubleClick, onClickOutside: onOutsideClick, onDragging: onDragging, onDragEnd: onDragEnd, "data-e2e": 'TextboxCard_StickyCard', children: [(0, jsx_runtime_1.jsx)(StyledScrollView, { contentSize: textSize.height, hasScroll: textSize.height >= rect.height, "data-e2e": 'TextboxCard_StyledScrollView', children: (0, jsx_runtime_1.jsx)(TextContainer, { role: "dialog", "data-e2e": 'TextboxCard_TextContainer', children: (0, jsx_runtime_1.jsx)(StyledStickyText, { ref: textRef, text: (sticky === null || sticky === void 0 ? void 0 : sticky.text) || text || '', selected: selected || false, editing: isEditing, dragging: isCanDrag, onInput: onTextChange, "data-e2e": 'TextboxCard_StyledStickyText' }) }) }), isOverlayVisible && ((0, jsx_runtime_1.jsx)(StyledStickyDragOverlay, { hint: touchEventsSupported
                    ? (0, i18n_1.Localized)(i18n_1.Strings.tools.textbox.dragPlaceholderTouch)
                    : (0, i18n_1.Localized)(i18n_1.Strings.tools.textbox.dragPlaceholder), "data-e2e": 'TextboxCard_StyledStickyDragOverlay' }))] }, `${(_a = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _a === void 0 ? void 0 : _a.x}-${(_b = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _b === void 0 ? void 0 : _b.y}`));
}
exports.default = (0, react_1.memo)(TextboxCard, (prevProps, nextProps) => {
    return (0, isEqual_1.default)(prevProps, nextProps);
});
const StyledScrollView = (0, styled_components_1.default)(ui_1.ScrollView) `
  position: relative;

  flex-grow: 1;

  width: 100%;
`;
const TextContainer = styled_components_1.default.div `
  flex-shrink: 0;

  width: 100%;
`;
const StyledStickyText = (0, styled_components_1.default)(StickyText_1.default) `
  user-select: ${({ dragging }) => (dragging ? 'none' : 'text')};
`;
const StyledStickyDragOverlay = (0, styled_components_1.default)(StickyDragOverlay_1.default) `
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
